import { Box, ButtonBase, Typography, styled } from "@mui/material";

import Modal from "./Modal";
import { useState } from "react";

const convertTextToHTML = (text) => {
  return { __html: text };
};

function HelpBox({ questions, title }) {
  const [openAnswerModal, setOpenAnswerModal] = useState();
  const [selectedQuestion, setSelectedQuestion] = useState();

  const handleClickQuestionBox = (question) => {
    setOpenAnswerModal(true);

    setSelectedQuestion(question);
  };

  return (
    <>
      <Box>
        <Typography variant="h5" color="text.main" textAlign="right" mb={2}>
          {title}
        </Typography>

        {questions?.map((question) => (
          <QuestionBox
            component={ButtonBase}
            onClick={() => handleClickQuestionBox(question)}
          >
            <Typography
              fontWeight={500}
              dir="rtl"
              color="text.main"
              variant="h6"
            >
              {question.title}
            </Typography>
          </QuestionBox>
        ))}
      </Box>

      <Modal
        title={<Typography dir="rtl">{selectedQuestion?.title}</Typography>}
        maxWidth="sm"
        dir="rtl"
        open={openAnswerModal}
        onClose={() => setOpenAnswerModal(false)}
      >
        <ContentWrapper
          dir="rtl"
          dangerouslySetInnerHTML={convertTextToHTML(selectedQuestion?.answer)}
        ></ContentWrapper>
      </Modal>
    </>
  );
}

const QuestionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: "8px",
  background: theme.palette.background.primaryGradient,
  marginBottom: theme.spacing(1),
  width: "100%",
  justifyContent: "flex-start",
  direction: "rtl",
  textAlign: "right",
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  ".blue-text": {
    color: theme.palette.text.alternate,
  },

  ".red-text": {
    color: theme.palette.error.main,
  },

  "n-weight-500": {
    fontWeight: 500,
  },

  "n-weight-600": {
    fontWeight: 600,
  },

  "n-weight-700": {
    fontWeight: 700,
  },
}));

export default HelpBox;
